import uuid4 from 'uuid4';
import {ShowRecaptchaPopup} from "./Recaptcha";

const simStatus = {
    initialized: 'initialized',
    duplicated: 'duplicated',
    checking: 'checking',
    checked_success: 'checked_success',
    checked_error: 'checked_error',
    checked_not_available: 'checked_not_available',
    checked_available: 'checked_available',
    checked_available_premium: 'checked_available_premium',
    invalid_ooredoo_number: 'invalid_ooredoo_number',
    invalid_city: 'invalid_city',
};


export default class SimFactory {
    constructor() {
        this.secret_code = '';
        this._city = '';
        this._limit = 0;
        this._sims = [];
        this.requiredSims = [];
        this.initSims = this.initSims.bind(this);
        this.resetSims = this.resetSims.bind(this);
        this.buildSimsFields = this.buildSimsFields.bind(this);
        this.simTemplate = this.simTemplate.bind(this);
        this.checkSimAvailability = this.checkSimAvailability.bind(this);
        this.reserveSims = this.reserveSims.bind(this);
        this.isValid = this.isValid.bind(this);
        this.hasPremiumNumbers = this.hasPremiumNumbers.bind(this);
        this.checkSimStatusMessage = this.checkSimStatusMessage.bind(this);
        this.handleAjaxError = this.handleAjaxError.bind(this);
        this.resendActivation = this.resendActivation.bind(this);
        this.openConfirmationForm = this.openConfirmationForm.bind(this);
        this.trackSimStatus = this.trackSimStatus.bind(this);
        this.setCity = this.setCity.bind(this);
        this.afterAvailabilityChecked = this.afterAvailabilityChecked.bind(this);
        this.isDuplicated = this.isDuplicated.bind(this);

    }

    resetSims() {
        this._limit = 0;
        this._sims = [];
        this.requiredSims = [];
    }

    initSims(limit) {

        let toLimit = limit - this._limit;
        if (!toLimit) {
            toLimit = 1;
        }
        if (limit < this._limit) {
            toLimit = this._limit - limit;
            while (limit < this._limit) {
                this.requiredSims.pop();
                --this._limit;
            }
            return;
        }

        this._limit = limit;
        let indexCounter = this.requiredSims.length;
        console.log('toLimit', toLimit)
        for (let _i = 0; _i < toLimit; ++_i) {
            const id = uuid4().replace(/-/g, '');
            this.requiredSims.push({
                index: indexCounter,
                id: `sim-${id}`,
                msisdn: '',
                balance: 0,
                available: false,
                is_premium: false,
                is_reserved: false,
                is_duplicated: false,
                status: simStatus.initialized
            });
            ++indexCounter;
        }


    }

    setCity(city) {
        this._city = city;
    }

    getCity(city) {
        return this._city;
    }

    buildSimsFields(target) {
        target.empty();
        const simOptions = {
            sim_price: 0
        };
        if (typeof target.data('sim_price') !== 'undefined') {
            let simPrice = parseFloat(target.data('sim_price'));
            if (!isNaN(simPrice) && simPrice > 0) {
                simOptions.sim_price = simPrice;
            }
        }

        for (let _i = 0; _i < this._limit; ++_i) {
            const sim = this.requiredSims[_i];
            const template = $(this.simTemplate(sim, simOptions));
            const simNumber = template.find(`.msisdn`);
            const simBalance = template.find(`.sim-balance`);
            const simCostWrapper = template.find(`.sim-cost__wrapper`);

            const msgEl = simNumber.closest('.sim-search-wrapper').find('.availability-message');

            simNumber.val(sim.msisdn);
            simBalance.val(sim.balance);

            target.append(template);

            simNumber.on('change', (e) => {
                sim.msisdn = e.target.value;
                sim.available = false;
                sim.is_premium = false;
                sim.status = simStatus.initialized;
                sim.is_duplicated = this.isDuplicated(sim.index, sim.msisdn);
                // console.log('sim.is_duplicated', sim.is_duplicated)
                if (sim.is_duplicated) {
                    msgEl.html(window.application.oss.translations.oss_form.sim_availability_messages[simStatus.duplicated]);
                } else {
                    msgEl.html('');
                }
            });

            simBalance.on('change', (e) => {
                sim.balance = parseInt(e.target.value, 10);
                if (simOptions.sim_price > 0) {
                    let total = sim.balance + simOptions.sim_price;
                    simCostWrapper.find('.sim-cost__total').text(`${total}` + ' ' + ' شيكل');
                }

            });

            template.find(`.search-btn`).on('click', (e) => {
                this.checkSimAvailability(simNumber.parents('form'), sim)
            })
        }
    }

    isDuplicated(simPosition, msisdn) {
        for (let i = 0; i < this.requiredSims.length; ++i) {
            const sim = this.requiredSims[i];
            // console.log('sim.index2', simPosition, i, sim.msisdn);
            if (simPosition !== i) {
                if (sim.msisdn === msisdn) {
                    return true;
                }
            }
        }
        return false;
    }

    simTemplate(sim, options = {}) {
        const simOptions = $.extend({
            sim_price: 0
        }, options);

        let _areaCode = '';
        let _city = application.oss.cities[this.getCity()];
        if (_city) {
            _areaCode = _city.local_area;
        }
        let _ratePlanOptions = '';
        _ratePlanOptions += `<option value="" disabled selected>${application.oss.translations.oss_form.select_rate_plan}</option>`;
        $.each(application.oss.rate_plans, function (index, _ratePlan) {
            if (_areaCode.length) {
                if (_areaCode === _ratePlan.local_area || _ratePlan.local_area === 'westbank_gaza') {
                    _ratePlanOptions += `<option value="${_ratePlan.id}">${_ratePlan.label}</option>`;
                }
            } else {
                _ratePlanOptions += `<option value="${_ratePlan.id}">${_ratePlan.label}</option>`;
            }
        });

        let priceTotalWrapper = '';
        if (simOptions.sim_price > 0) {

            priceTotalWrapper = `
<div class="form-group input-wrapper sim-cost__wrapper">
        <div class="sim-cost__price">
        سعر الشريحة: 
         <span class="col-main">
         ${simOptions.sim_price}
          شيكل
        </span>
        
         </div>
        <div class="sim-cost__total_box">
        المجموع:
        <span class="sim-cost__total col-main">
        ${simOptions.sim_price}
         شيكل
        </span>
        </div>
</div>
`;
        }

        return `<div id="${sim.id}" class="sim-number--wrapper sim-number--${sim.index}" data-sim_index="${sim.index}">
                                    <div class="purchased-sim-title">
                                        ${application.oss.translations.oss_form.sim_order_index} ${sim.index + 1} 
                                    </div>
                                    <div class="form-group input-wrapper sim-search-wrapper">
                                        <label for="total_sims" class="main-label">${application.oss.translations.oss_form.type_sim_number}</label>
                                        <div class="form-group__element form-group__element--with-icon">
                                            <input type="tel" name="sims[${sim.index + 1}][msisdn]" maxlength="10" class="msisdn customer-info-inputs " placeholder="رقم الموبايل" required="true"/>
                                            <i class="form-element-icon icon-oss-mobile"></i>
                                            
                                        </div>
                                        <div class="form-group__element">
                                         <button type="button" class="main-btn main-btn--icon main-btn--icon-right search-btn">
                                            <i class="icon-search"></i>
                                            <span>${application.oss.translations.oss_form.search}</span>
                                        </button>
                                        </div>
                                        <div class="form-group__element">
                                            <div class="availability-message"></div>
                                        </div>
                                    </div>
                                    <div class="form-group input-wrapper sim-balance-wrapper">
                                        <label for="total_sims" class="main-label">${application.oss.translations.oss_form.type_sim_balance}</label>
                                        <div class="form-group__element form-group__element-balance">
                                            <select class="sim-balance custom-select" required="true" name="sims[${sim.index + 1}][balance]">
                                                <option value="" disabled selected>${application.oss.translations.oss_form.select_balance_amount}</option>
                                                <option value="15">15</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                            </select>
                                            
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="form-group input-wrapper sim-balance-wrapper">
                                        <label for="total_sims" class="main-label">${application.oss.translations.oss_form.rate_plan_label}</label>
                                        <div class="form-group__element form-group__element-rate_plan ">
                                            <select class="custom-select" required="true" name="sims[${sim.index + 1}][rate_plan]">
                                                ${_ratePlanOptions}
                                            </select>
                                            
                                        </div>
                                        
                                    </div>
                                    
                                    ${priceTotalWrapper}
                                </div>`
    }

    checkSimAvailability(form, sim) {
        sim.is_duplicated = this.isDuplicated(sim.index, sim.msisdn);
        if (sim.is_duplicated) {
            const target = $(`#${sim.id} .availability-message`);
            target.addClass('availability-message-error');
            target.removeClass('availability-message-success');
            target.text(application.oss.translations.oss_form.sim_availability_messages[simStatus.duplicated])
            return false;
        }
        const factory = this;

        return $.ajax({
            url: application.oss.urls.check_sim_availability,
            dataType: 'json',
            method: 'post',
            xhrFields: {
                withCredentials: true
            },
            data: {
                number: sim.msisdn,
                city: this._city,
                balance: sim.balance,
                [application.requestToken.key]: application.requestToken.value
            },

            beforeSend: () => {
                sim.available = false;
                sim.is_premium = false;
                sim.status = simStatus.checking;
                this.checkSimStatusMessage(sim);
                form.find('button').attr('disabled', true);
                $(`#${sim.id} .oss-sim-suggested-list`).remove();

            },

            success: (response) => {
                if (typeof response.available !== 'undefined') {
                    if (response.available === true && !response.is_premium) {
                        sim.available = true;
                        sim.is_premium = false;
                        sim.status = simStatus.checked_available;
                    } else {
                        if (response.is_premium) {
                            sim.is_premium = true;
                            sim.available = false;
                            sim.status = simStatus.checked_available_premium;
                        } else {
                            sim.status = simStatus.checked_not_available;
                        }
                    }
                } else {
                    sim.status = simStatus.checked_error
                }
                this.checkSimStatusMessage(sim);

                this.afterAvailabilityChecked(form);

                if (typeof response.suggested_msisdn !== 'undefined' && response.suggested_msisdn.length) {
                    $(`#${sim.id}`).find('.oss-sim-suggested-list').remove();
                    const parentDom = $(`#${sim.id} .availability-message`).parent().parent();

                    parentDom.after(response.suggested_msisdn);
                    $(`#${sim.id}`).on('click', '.oss-sim-suggested-list__item', function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        $(`#${sim.id}`).find('.msisdn').val($(this).data('msisdn'));
                        $(`#${sim.id}`).find('.msisdn').trigger('change');

                        factory.checkSimAvailability($(`#${sim.id}`).closest('form'), sim)

                    })
                }
            },
            complete: () => {
                form.find('button').attr('disabled', false);
            },
            error: (xhr) => {
                form.find('button').attr('disabled', false);
                let message = '';
                if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.error_code !== 'undefined' && typeof simStatus[xhr.responseJSON.error_code] !== 'undefined') {
                    sim.status = xhr.responseJSON.error_code;
                } else if (typeof xhr.responseJSON !== 'undefined' && typeof xhr.responseJSON.message !== 'undefined' && typeof simStatus[xhr.responseJSON.error_code] === 'undefined') {
                    simStatus[xhr.responseJSON.error_code] = xhr.responseJSON.error_code;
                    application.oss.translations.oss_form.sim_availability_messages[xhr.responseJSON.error_code] = xhr.responseJSON.message;
                    sim.status = xhr.responseJSON.error_code;
                } else {
                    sim.status = simStatus.checked_error;
                }

                ShowRecaptchaPopup(xhr);

                this.checkSimStatusMessage(sim);
            }
        })
    }

    afterAvailabilityChecked(form) {
        let hasPremium = false;
        let hasNotAvailable = false;
        let hasDuplicated = false;

        form.removeClass('has-premium');
        form.removeClass('has-duplicated');
        form.removeClass('has-not-available');
        form.removeClass('disabled-form-steps');

        for (let i = 0; i < this.requiredSims.length; ++i) {
            const sim = this.requiredSims[i];
            if (sim.status !== simStatus.initialized) {
                const simWrapper = form.find(`.sim-number--wrapper.sim-number--${sim.index}`);

                sim.is_duplicated = this.isDuplicated(sim.index, sim.msisdn);
                simWrapper.removeClass('premium-sim');
                simWrapper.removeClass('sim-is-not-available');
                simWrapper.removeClass('is-duplicated-sim');

                if (sim.is_duplicated) {
                    hasDuplicated = true;
                    simWrapper.addClass('is-duplicated-sim');
                }
                if (sim.is_premium) {
                    hasPremium = true;
                    simWrapper.addClass('premium-sim');
                }

                if (!sim.available) {
                    hasNotAvailable = true;
                    simWrapper.addClass('sim-is-not-available');
                }

            }
        }
        if (hasPremium) {
            form.addClass('has-premium');
            form.addClass('disabled-form-steps');
        }
        if (hasNotAvailable) {
            form.addClass('has-not-available');
            // form.addClass('disabled-form-steps');
        }
        if (hasDuplicated) {
            form.addClass('has-duplicated');
            form.addClass('disabled-form-steps');
        }

        // console.log('this.requiredSims', this.requiredSims)
    }

    reserveSims(form, callbacks) {
        const factory = this;
        if (!form.find('#csrf').length) {
            form.append(`<input id="csrf" type="hidden" name="${application.requestToken.key}" value="${application.requestToken.value}" />`);
        }
        if (this.secret_code.length) {
            if (!form.find('#secret_code').length) {
                form.append(`<input type="hidden" id="secret_code" name="secret_code" value="${this.secret_code}" />`);
            } else {
                form.find('#secret_code').val(this.secret_code);
            }
        }

        if (typeof callbacks.ProcessForm === 'function') {
            callbacks.ProcessForm(form);
        }

        const formData = form.serialize();

        // formData['ekyc_id'] = this.getEkycData(form);

        $.ajax({
            url: application.oss.urls.reserve_sim,
            dataType: 'json',
            method: 'post',
            data: formData,
            xhrFields: {
                withCredentials: true
            },
            beforeSend: function () {
                form.find('.error-name').remove();
                form.find('button').attr('disabled', true);
            },
            success: (response) => {
                if (typeof response.status !== 'undefined') {
                    this.secret_code = response.secret_code;
                    this.onSimReservedSucceed(response);

                    if (typeof callbacks.onSuccess === 'function') {
                        callbacks.onSuccess(response);
                    }
                } else {
                    if (typeof callbacks.onFailed === 'function') {
                        callbacks.onFailed(response);
                    }
                    $.alert({
                        title: '',
                        content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${application.oss.translations.oss_form.unknown_error_occurred}</div>
                                                `,
                    })
                }
            },
            complete: function () {
                form.find('button').attr('disabled', false);
            },
            error: (xhr) => {
                form.find('button').attr('disabled', false)
                const errorsHandler = this.handleAjaxError(xhr);
                let message = `<p>${errorsHandler.message}</p>`;
                if (typeof errorsHandler.error_code !== 'undefined' && typeof application.oss.translations.oss_form.error_codes[errorsHandler.error_code] !== 'undefined') {
                    message = `<p>${application.oss.translations.oss_form.error_codes[errorsHandler.error_code]}</p>`;
                    if (errorsHandler.error_code === 'you_have_sent_your_order') {
                        message += `<p>${application.oss.translations.oss_form.confirmation_code_resend} <a href="#" class="resend-activation confirm-link">${application.oss.translations.oss_form.click_here}</a></p>`;
                        message += `<p><a href="#" class="open-confirmation-form confirm-link">${application.oss.translations.oss_form.or_click_here}</a> ${application.oss.translations.oss_form.to_fill_confirmation_code}</p>`;
                    }
                }
                if (typeof errorsHandler.errors !== 'undefined' && typeof errorsHandler.errors === 'object') {
                    if (typeof errorsHandler.errors.form_fields !== 'undefined' && typeof errorsHandler.errors.form_fields === 'object') {
                        $.each(errorsHandler.errors.form_fields, function (i, error) {
                            const field = form.find(`[name="${error.field}"]`);
                            let parent = field.parents('.form-group__element');
                            if (!parent.length) {
                                parent = field.parents('.input-wrapper').last();
                            }
                            if (field.length && parent.length) {
                                parent.append(`<div class="error-name">${error.message}</div>`);
                            } else {
                                message += `<p>${error.message}</p>`
                            }
                        })
                    }
                }
                if (ShowRecaptchaPopup(xhr)) {
                    return;
                }

                $.alert({
                    title: '',
                    content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                `,
                    onContentReady: function () {
                        var jc = this;
                        this.$content.find('.resend-activation').on('click', function (e) {
                            e.preventDefault();
                            factory.resendActivation();
                        });

                        this.$content.find('.open-confirmation-form').on('click', function (e) {
                            e.preventDefault();
                            factory.openConfirmationForm()
                        });
                    },
                    buttons: {
                        close: {
                            text: application.oss.translations.oss_form.close,
                            btnClass: 'main-btn',
                        },
                    }
                });

                if (typeof callbacks.onFailed === 'function') {
                    callbacks.onFailed(errorsHandler, xhr);
                }

            }

        })
    }

    getEkycData(form) {
        const field = form.find('[name="ekyc_id"]');

        if (field.length) {
            return field.val();
        }
        return null;
    }

    validateStepRequest(form, validationUrl, options = {}) {
        const factory = this;

        const stepContent = form.find(`#wizard-p-${options.currentStepIndex}`);
        // window.__form = form;

        // const formData = form.serialize();
        const formData = {};
        $.each(stepContent.find('input,select,textarea'), function (idx, el) {
            formData[$(el).attr('name')] = $(el).val();
        });
        formData['current_step_index'] = options.currentStepIndex;
        formData['current_step_id'] = options.currentStepIndex + 1;
        formData[application.requestToken.key] = application.requestToken.value;
        if (this.secret_code.length) {
            formData['secret_code'] = this.secret_code;
        }

        formData['ekyc_id'] = this.getEkycData(form);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: validationUrl,
                dataType: 'json',
                method: 'post',
                data: formData,
                xhrFields: {
                    withCredentials: true
                },
                beforeSend: function () {
                    form.find('.error-name').remove();
                    form.find('button').attr('disabled', true)
                },
                success: (response) => {
                    if (typeof options.onSuccess === 'function') {
                        options.onSuccess(response);
                    }
                    resolve(true);
                },
                complete: function () {
                    form.find('button').attr('disabled', false);
                },
                error: (xhr) => {
                    form.find('button').attr('disabled', false);
                    const errorsHandler = this.handleAjaxError(xhr);
                    let message = `<p>${errorsHandler.message}</p>`;
                    if (typeof errorsHandler.error_code !== 'undefined' && typeof application.oss.translations.oss_form.error_codes[errorsHandler.error_code] !== 'undefined') {
                        message = `<p>${application.oss.translations.oss_form.error_codes[errorsHandler.error_code]}</p>`;
                        if (errorsHandler.error_code === 'you_have_sent_your_order') {
                            message += `<p>${application.oss.translations.oss_form.confirmation_code_resend} <a href="#" class="resend-activation confirm-link">${application.oss.translations.oss_form.click_here}</a></p>`;
                            message += `<p><a href="#" class="open-confirmation-form confirm-link">${application.oss.translations.oss_form.or_click_here}</a> ${application.oss.translations.oss_form.to_fill_confirmation_code}</p>`;
                        }
                    }
                    if (typeof errorsHandler.errors !== 'undefined' && typeof errorsHandler.errors === 'object') {
                        if (typeof errorsHandler.errors.form_fields !== 'undefined' && typeof errorsHandler.errors.form_fields === 'object') {
                            $.each(errorsHandler.errors.form_fields, function (i, error) {
                                const field = form.find(`[name="${error.field}"]`);
                                let parent = field.parents('.form-group__element');
                                if (!parent.length) {
                                    parent = field.parents('.input-wrapper').last();
                                }
                                if (field.length && parent.length) {
                                    parent.append(`<div class="error-name">${error.message}</div>`);
                                } else {
                                    message += `<p>${error.message}</p>`
                                }
                            })
                        }
                    }
                    if (ShowRecaptchaPopup(xhr)) {
                        reject(xhr);
                        return;
                    }

                    $.alert({
                        title: '',
                        content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                `,
                        onContentReady: function () {
                            var jc = this;
                            this.$content.find('.resend-activation').on('click', function (e) {
                                e.preventDefault();
                                factory.resendActivation();
                            });

                            this.$content.find('.open-confirmation-form').on('click', function (e) {
                                e.preventDefault();
                                factory.openConfirmationForm()
                            });
                        },
                        buttons: {
                            close: {
                                text: application.oss.translations.oss_form.close,
                                btnClass: 'main-btn',
                            },
                        }
                    });

                    if (typeof options.onFailed === 'function') {
                        options.onFailed(errorsHandler, xhr);
                    }

                    reject(xhr);

                }

            })
        });

    }

    validateRequest(form, callbacks) {
        const factory = this;
        if (!form.find('#csrf').length) {
            form.append(`<input id="csrf" type="hidden" name="${application.requestToken.key}" value="${application.requestToken.value}" />`);
        }
        if (this.secret_code.length) {
            if (!form.find('#secret_code').length) {
                form.append(`<input type="hidden" id="secret_code" name="secret_code" value="${this.secret_code}" />`);
            } else {
                form.find('#secret_code').val(this.secret_code);
            }
        }
        // formData['ekyc_id'] = this.getEkycData(form);

        const formData = form.serialize();


        $.ajax({
            url: application.oss.urls.validate_before_submit,
            dataType: 'json',
            method: 'post',
            data: formData,
            xhrFields: {
                withCredentials: true
            },
            beforeSend: function () {
                form.find('.error-name').remove();
                form.find('button').attr('disabled', true)
            },
            success: (response) => {
                if (typeof response.status !== 'undefined') {
                    if (typeof callbacks.onSuccess === 'function') {
                        callbacks.onSuccess(response);
                    }
                } else {
                    if (typeof callbacks.onFailed === 'function') {
                        callbacks.onFailed(response);
                    }
                    $.alert({
                        title: '',
                        content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${application.oss.translations.oss_form.unknown_error_occurred}</div>
                                                `,
                    })
                }
            },
            complete: function () {
                form.find('button').attr('disabled', false);
            },
            error: (xhr) => {
                form.find('button').attr('disabled', false);
                const errorsHandler = this.handleAjaxError(xhr);
                let message = `<p>${errorsHandler.message}</p>`;
                if (typeof errorsHandler.error_code !== 'undefined' && typeof application.oss.translations.oss_form.error_codes[errorsHandler.error_code] !== 'undefined') {
                    message = `<p>${application.oss.translations.oss_form.error_codes[errorsHandler.error_code]}</p>`;
                    if (errorsHandler.error_code === 'you_have_sent_your_order') {
                        message += `<p>${application.oss.translations.oss_form.confirmation_code_resend} <a href="#" class="resend-activation confirm-link">${application.oss.translations.oss_form.click_here}</a></p>`;
                        message += `<p><a href="#" class="open-confirmation-form confirm-link">${application.oss.translations.oss_form.or_click_here}</a> ${application.oss.translations.oss_form.to_fill_confirmation_code}</p>`;
                    }
                }
                if (typeof errorsHandler.errors !== 'undefined' && typeof errorsHandler.errors === 'object') {
                    if (typeof errorsHandler.errors.form_fields !== 'undefined' && typeof errorsHandler.errors.form_fields === 'object') {
                        $.each(errorsHandler.errors.form_fields, function (i, error) {
                            const field = form.find(`[name="${error.field}"]`);
                            let parent = field.parents('.form-group__element');
                            if (!parent.length) {
                                parent = field.parents('.input-wrapper').last();
                            }
                            if (field.length && parent.length) {
                                parent.append(`<div class="error-name">${error.message}</div>`);
                            } else {
                                message += `<p>${error.message}</p>`
                            }
                        })
                    }
                }
                if (ShowRecaptchaPopup(xhr)) {
                    return;
                }

                $.alert({
                    title: '',
                    content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                `,
                    onContentReady: function () {
                        var jc = this;
                        this.$content.find('.resend-activation').on('click', function (e) {
                            e.preventDefault();
                            factory.resendActivation();
                        });

                        this.$content.find('.open-confirmation-form').on('click', function (e) {
                            e.preventDefault();
                            factory.openConfirmationForm()
                        });
                    },
                    buttons: {
                        close: {
                            text: application.oss.translations.oss_form.close,
                            btnClass: 'main-btn',
                        },
                    }
                });

                if (typeof callbacks.onFailed === 'function') {
                    callbacks.onFailed(errorsHandler, xhr);
                }

            }

        })
    }

    resendActivation() {
        const factory = this;
        $.confirm({
            title: '',
            content: () => {
                if (this.secret_code && this.secret_code.length) {
                    return `<form onsubmit="return false;" class="formName">
                                        <div class="form-group confirm-content input-wrapper">
                                            <div >${application.oss.translations.oss_form.resend_confirmation_code_with_secret}</div>
                                            <input dir="ltr" type="hidden" name="secret_code" value="${this.secret_code}" class="popup-input" />
                                        </div>
                                    </form>`
                }
                return `<form onsubmit="return false;" class="formName">
                                        <div class="form-group confirm-content input-wrapper">
                                            <div class="confirm-label">${application.oss.translations.oss_form.email}</div>
                                            <input dir="ltr" type="email" name="email" placeholder="${application.oss.translations.oss_form.email}" class="customer-info-inputs confirm-input popup-input" />
                                        </div>
                                        <div class="form-group confirm-content input-wrapper">
                                            <div class="confirm-label" >${application.oss.translations.oss_form.resend_activation_contact_number}</div>
                                            <input dir="ltr" type="tel" name="contact_number" placeholder="${application.oss.translations.oss_form.resend_activation_contact_number}" class="customer-info-inputs confirm-input popup-input" />
                                        </div>
                                        <div class="form-group confirm-content input-wrapper">
                                            <div class="confirm-label">${application.oss.translations.oss_form.required_sim_msisdn}</div>
                                            <input dir="ltr" type="tel" name="required_sim_msisdn" placeholder="${application.oss.translations.oss_form.required_sim_msisdn}" class="customer-info-inputs confirm-input popup-input" />
                                        </div>
                                        
                                    </form>`
            },
            onContentReady: function () {
                var jc = this;
                // this.$content.find('.close-btn').on('click', function (e) {
                //     e.preventDefault();
                //     jc.close();
                // });
            },
            buttons: {
                resend: {
                    text: application.oss.translations.oss_form.resend_confirmation_code,
                    btnClass: 'main-btn',
                    action: function () {
                        var jc = this;
                        const popupForm = this.$content.find('form');
                        let hasError = false;
                        popupForm.find('.error-name').remove();

                        $.each(popupForm.find('input'), function (i, input) {
                            if (!$(input).val().length) {
                                hasError = true;
                                $(input).parent().append(`<div class="error-name" >${application.oss.translations.oss_form.required_field}</div>`);
                            }
                        });
                        if (hasError) {
                            return false;
                        }

                        popupForm.append(`<input id="csrf" type="hidden" name="${application.requestToken.key}" value="${application.requestToken.value}" />`);

                        $.ajax({
                            url: application.oss.urls.resend_activation_code,
                            dataType: 'json',
                            method: 'post',
                            data: popupForm.serialize(),
                            xhrFields: {
                                withCredentials: true
                            },
                            beforeSend: () => {
                                jc.showLoading();
                            },
                            success: (response) => {
                                let message = application.oss.translations.oss_form.unknown_error_occurred;
                                let isError = true;
                                if (typeof response.status !== 'undefined' && response.status === true) {
                                    isError = false;
                                    message = application.oss.translations.oss_form.confirmation_sent_successfully;
                                    if (!factory.secret_code.length) {
                                        factory.secret_code = response.secret_code;
                                    }
                                }
                                jc.close();
                                $.alert({
                                    title: '',
                                    content: `${isError ? '<div class="close-icon"><i class="icon-cancel1"></i> </div>' : '<div class="check-icon"><i class="icon-checkmark"></i> </div>'}
                                              <div class="confirm-content"><div class="confirm-div">${message}</div>
                                              `,
                                    buttons: {
                                        close: {
                                            text: application.oss.translations.oss_form.close,
                                            btnClass: 'main-btn',
                                            action: function () {
                                            }
                                        },
                                    }
                                })
                            },
                            complete: () => {
                                jc.hideLoading();
                            },
                            error: (xhr) => {
                                const errorsHandler = factory.handleAjaxError(xhr);
                                jc.hideLoading();

                                if (ShowRecaptchaPopup(xhr)) {
                                    return;
                                }

                                $.alert({
                                    title: '',
                                    content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${errorsHandler.message}</div>
                                                `,
                                    buttons: {
                                        close: {
                                            text: application.oss.translations.oss_form.close,
                                            btnClass: 'main-btn',
                                        },
                                    }
                                })

                            }
                        })

                        return false;
                    }
                },
                close: {
                    text: application.oss.translations.oss_form.close,
                    btnClass: 'main-btn-gray',
                },
            },
        });

    }

    onSimReservedSucceed(response) {
        this.openConfirmationForm();
    }

    openConfirmationForm() {
        const factory = this;

        $.confirm({
            title: '',
            content: function () {
                let confText = application.oss.translations.oss_form.confirmation_code_text;

                if($('.esim-replacement').length){
                    confText = application.oss.translations.oss_form.confirmation_code_text_esim_swap;
                }

                return `<form onsubmit="return false;" action="" class="formName">
                                <div class="form-group confirm-content input-wrapper">
                                    <div class="confirm-label">${confText}</label>
                                    <input dir="ltr" type="tel" min="6" name="confirmation_code" placeholder="${application.oss.translations.oss_form.confirmation_code}" class="customer-info-inputs confirm-input" required />
                                </div>
                                <div class="form-group confirm-content input-wrapper">
                                    <div class="confirm-label confirm-label-small">${application.oss.translations.oss_form.confirmation_code_resend} <a href="#" class="resend-activation confirm-link">${application.oss.translations.oss_form.click_here}</a></div>
                                </div>
                                
                            </form>`
            },
            onContentReady: function () {
                var jc = this;
                // this.$content.find('.close-btn').on('click', function (e) {
                //     e.preventDefault();
                //     jc.close();
                // });
                this.$content.find('.resend-activation').on('click', function (e) {
                    e.preventDefault();
                    factory.resendActivation();
                });
            },
            buttons: {
                formSubmit: {
                    text: application.oss.translations.oss_form.confirm_order,
                    btnClass: 'main-btn',
                    action: function () {
                        var jc = this;

                        const popupForm = this.$content.find('form');
                        let hasError = false;
                        popupForm.find('.error-name').remove();

                        $.each(popupForm.find('input'), function (i, input) {
                            if (!$(input).val().length) {
                                hasError = true;
                                $(input).parent().append(`<div class="error-name" >${application.oss.translations.oss_form.required_field}</div>`);
                            } else if (parseInt($(input).attr('min'), 10) > 0 && $(input).val().length < $(input).attr('min')) {
                                hasError = true;
                                let err = application.oss.translations.oss_form.minimum_chars_is.replace(/__MIN__/g, $(input).attr('min'));
                                $(input).parent().append(`<div class="error-name" >${err}</div>`);
                            }
                        });
                        if (hasError) {
                            return false;
                        }

                        if (!popupForm.find('#csrf').length) {
                            popupForm.append(`<input id="csrf" type="hidden" name="${application.requestToken.key}" value="${application.requestToken.value}" />`);
                        } else {
                            popupForm.find('#csrf').attr('name', application.requestToken.key);
                            popupForm.find('#csrf').val(application.requestToken.value);
                        }

                        if (factory.secret_code && factory.secret_code.length) {
                            if (!popupForm.find('#secret_code').length) {
                                popupForm.append(`<input type="hidden" id="secret_code" name="secret_code" value="${factory.secret_code}" />`);
                            } else {
                                popupForm.find('#secret_code').val(factory.secret_code);
                            }
                        }

                        $.ajax({
                            url: application.oss.urls.confirm_order,
                            dataType: 'json',
                            method: 'post',
                            data: popupForm.serialize(),
                            xhrFields: {
                                withCredentials: true
                            },
                            beforeSend: () => {
                                jc.showLoading();
                            },
                            success: (response) => {
                                let passed = false;
                                let message = application.oss.translations.oss_form.unknown_error_occurred;
                                let formHtml = '';
                                let hasForm = false;
                                let is_online_payment = false;

                                if (typeof response.status !== 'undefined' && response.status === true) {
                                    passed = true;
                                    message = application.oss.translations.oss_form.your_order_activated_successfully;
                                    if (typeof response.message !== 'undefined') {
                                        message = response.message;
                                    }

                                    if (typeof response.form === 'string' && response.form.length) {
                                        formHtml = response.form;
                                        hasForm = true;
                                    }
                                    if (typeof response.is_online_payment !== 'undefined' && response.is_online_payment) {
                                        is_online_payment = response.is_online_payment;
                                    }

                                }

                                if (!passed) {
                                    $.alert({
                                        title: '',

                                        content: `${passed ? '<div class="check-icon"><i class="icon-checkmark"></i> </div>' : '<div class="close-icon"><i class="icon-cancel1"></i> </div>'}
                                              <div class="confirm-content"><div class="confirm-div">${message}</div>
                                              `,

                                        buttons: {
                                            close: {
                                                text: application.oss.translations.oss_form.close,
                                                btnClass: 'main-btn',
                                                action: function () {
                                                }
                                            },
                                        }
                                    })
                                } else {
                                    jc.close();

                                    let buttons = {
                                        newSim: {
                                            text: application.oss.translations.oss_form.apply_new_order,
                                            btnClass: 'main-btn',
                                            action: function () {
                                                window.location.href = application.oss.urls.new_sim;
                                            }
                                        },
                                    };

                                    let responseMessage = `<div class="check-icon"><i class="icon-checkmark"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                      ${formHtml}
                                                      <div class="confirm-div confirm-div-small">
                                                      ${is_online_payment ? '' : `${application.oss.translations.oss_form.to_check_order_status} <a href="${application.oss.urls.track_sim}" class="confirm-link">${application.oss.translations.oss_form.click_here}</a>`}
                                                      </div>`;

                                    if (typeof response.is_esim === 'boolean' && true === response.is_esim) {
                                        buttons = {};
                                        buttons.download_esim_qr = {
                                            text: application.oss.translations.oss_form.download_esim_qr,
                                            btnClass: 'main-btn',
                                            action: function () {

                                                // jc.buttons.confirm_order.disable();
                                                // jc.buttons.cancel.disable();

                                                window.location.href = response.download_qr_url;
                                                return false;
                                            }
                                        };
                                        buttons.go_home = {
                                            text: application.oss.translations.oss_form.go_to_home,
                                            btnClass: 'main-btn',
                                            action: function () {
                                                window.location.href = application.url;
                                            }
                                        };

                                        responseMessage = `<div class="check-icon"><i class="icon-checkmark"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                      ${formHtml}
                                                      `;
                                    }

                                    $.confirm({
                                        title: '',
                                        content: responseMessage,
                                        onOpenBefore: function () {
                                            const me = this;
                                            me.$el.addClass('jconfirm-ooredoo');
                                            if (hasForm) {
                                                me.$el.addClass('jconfirm-ooredoo--no-buttons');

                                                $.each(me.buttons, function (aName, aBtn) {
                                                    aBtn.hide();
                                                });
                                            }
                                        },
                                        onContentReady: function () {
                                            const me = this;
                                            if (hasForm) {
                                                me.$content.find('.payment-method-form').submit();
                                            }
                                        },
                                        buttons: buttons,
                                    });

                                }
                            },
                            complete: () => {
                                jc.hideLoading();
                            },
                            error: (xhr) => {
                                const errorsHandler = factory.handleAjaxError(xhr);
                                jc.hideLoading();
                                let message = errorsHandler.message;
                                if (typeof errorsHandler.errors !== 'undefined' && typeof errorsHandler.errors === 'object') {
                                    if (typeof errorsHandler.errors.reservation_errors !== 'undefined' && typeof errorsHandler.errors.reservation_errors === 'object') {
                                        $.each(errorsHandler.errors.reservation_errors, function (i, error) {
                                            message += `<p>${error.message}</p>`
                                        })
                                    }
                                }

                                if (ShowRecaptchaPopup(xhr)) {
                                    return;
                                }

                                $.confirm({
                                    title: '',
                                    content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                `,
                                    buttons: {
                                        close: {
                                            text: application.oss.translations.oss_form.close,
                                            btnClass: 'main-btn',
                                        },
                                    },
                                });

                            }
                        })

                        return false;
                    }
                },
            },
        });

    }

    trackSimStatus(orderId) {
        const factory = this;
        return $.ajax({
            url: application.oss.urls.track_sim_status,
            dataType: 'json',
            method: 'post',
            data: {
                order_id: orderId,
                [application.requestToken.key]: application.requestToken.value
            },
            xhrFields: {
                withCredentials: true
            },
            beforeSend: () => {

            },
            success: (response) => {
                let passed = false;
                let message = application.oss.translations.oss_form.unknown_error_occurred;
                if (typeof response.status !== 'undefined' && response.status === true) {
                    passed = true;
                    message = application.oss.translations.oss_form.your_order_activated_successfully;
                    if (typeof response.message !== 'undefined') {
                        message = response.message;
                    }
                }
                if (!passed) {
                    $.alert({
                        title: '',
                        content: `${passed ? '<div class="check-icon"><i class="icon-checkmark"></i> </div>' : '<div class="close-icon"><i class="icon-cancel1"></i> </div>'}
                                              <div class="confirm-content"><div class="confirm-div">${message}</div>
                                              `,
                        buttons: {
                            close: {
                                text: application.oss.translations.oss_form.close,
                                btnClass: 'main-btn',
                                action: function () {
                                }
                            },
                        }
                    })
                }
                return response;
            },
            complete: () => {
            },

            error: (xhr) => {
                const errorsHandler = factory.handleAjaxError(xhr);
                let message = errorsHandler.message;
                if (typeof errorsHandler.errors !== 'undefined' && typeof errorsHandler.errors === 'object') {
                    if (typeof errorsHandler.errors.reservation_errors !== 'undefined' && typeof errorsHandler.errors.reservation_errors === 'object') {
                        $.each(errorsHandler.errors.reservation_errors, function (i, error) {
                            message += `<p>${error.message}</p>`
                        })
                    }
                }

                if (ShowRecaptchaPopup(xhr)) {
                    return;
                }

                $.confirm({
                    title: '',
                    content: `<div class="close-icon"><i class="icon-cancel1"></i> </div>
                                                      <div class="confirm-content"><div class="confirm-div">${message}</div>
                                                `,
                    buttons: {
                        close: {
                            text: application.oss.translations.oss_form.close,
                            btnClass: 'main-btn',
                        },
                    },
                });

            }
        })

    }

    handleAjaxError(xhr) {
        // data-grecaptcha_id
        const grecaptchaId = $('body').find('[data-grecaptcha_id]');
        if (grecaptchaId.length){
            $.each(grecaptchaId, function (idx,el){
                if (typeof window.grecaptcha !== 'undefined'){
                    let id = $(el).data('grecaptcha_id');
                    window.grecaptcha.reset(id);
                }

            });
        }

        let message = application.oss.translations.oss_form.unknown_error_occurred;
        const result = {
            message: message,
        };


        if (typeof xhr.responseJSON !== 'undefined') {
            if (typeof xhr.responseJSON.message !== 'undefined') {
                message = xhr.responseJSON.message;
            }
            if (typeof xhr.responseJSON.error_code !== 'undefined' && typeof application.oss.translations.oss_form.error_codes[xhr.responseJSON.error_code] !== 'undefined') {
                result.error_code = xhr.responseJSON.error_code;
            }
            if (typeof xhr.responseJSON.errors !== 'undefined') {
                result.errors = xhr.responseJSON.errors;
            }
        }
        result.message = message;
        return result;

    }

    checkSimStatusMessage(sim) {
        const target = $(`#${sim.id} .availability-message`);
        let message = '';

        if (sim.status === simStatus.initialized && sim.msisdn.length) {
            message = application.oss.translations.oss_form.sim_availability_messages[sim.status];
        } else if (sim.status === simStatus.initialized) {
            message = application.oss.translations.oss_form.sim_availability_messages[sim.status];
        } else if (sim.status !== simStatus.initialized && typeof application.oss.translations.oss_form.sim_availability_messages[sim.status] !== 'undefined') {
            message = application.oss.translations.oss_form.sim_availability_messages[sim.status];
        } else {
            message = application.oss.translations.oss_form.sim_availability_messages.checked_error;
        }

        console.log('sim', sim.status)

        target.removeClass('availability-message-success');
        target.removeClass('availability-message-error');
        if (sim.status !== 'checking') {
            if (!sim.available) {
                target.addClass('availability-message-error');
            } else if (sim.available && sim.status === 'checked_available') {
                target.addClass('availability-message-success');
            }
        }


        target.text(message);
    }

    isValid() {

        let isValid = true;
        for (let i = 0; i < this.requiredSims.length; ++i) {
            const sim = this.requiredSims[i];
            if (!sim.available) {
                isValid = false;
            }
            this.checkSimStatusMessage(sim)
        }

        return isValid;
    }

    hasPremiumNumbers() {

        let hasPremium = false;
        for (let i = 0; i < this.requiredSims.length; ++i) {
            const sim = this.requiredSims[i];
            if (sim.is_premium) {
                hasPremium = true;
                break;
            }
        }

        return hasPremium;
    }

}
